import LoadingButton from '@mui/lab/LoadingButton'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useDeleteFieldMutation } from '../../../services/fields/slice'

const DeleteField = ({ field, open, setOpen }) => {
  const [deleteField, { isLoading }] = useDeleteFieldMutation()

  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = async () => {
    await deleteField(field.id)
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{`Delete ${field?.givenName || 'Field'}?`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          If you delete this field, it will no longer be available for use in the application.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton disabled={isLoading} onClick={handleClose} autoFocus>
          Cancel
        </LoadingButton>
        <LoadingButton loading={isLoading} onClick={handleDelete}>
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteField
